module.exports = __webpack_public_path__ + "res/4-img_back_rtl.1e75bcabe008a94c338d102943f0bd6a.png";